import { connect } from 'react-redux';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { SearchIcon } from 'base/components/Icon/index';
import theme from 'theme/theme';
import Input from 'base/components/forms/Input';
import { closeModal, getIsModalOpen, openModal } from '../../modal';
import { search } from '../store/actions';
import { getSearchKey } from '../store/selectors';


const StyledInput = styled(Input)`
  background: transparent;
  color: ${theme.colors.dark};
  font-size: ${theme.fontSizes.large};
  padding: 0 0 0 30px;
  &::placeholder {
    color: ${theme.colors.medium};
  }
`;

const SearchBar = styled.div`
  position: relative;
  display: block;
  padding: 0 0 0 0;
  color: ${theme.colors.medium};
  font-size: ${theme.fontSizes.large};
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding: 0 0 0 20px;
  }
`;

const Icon = styled(SearchIcon)`
  position: absolute;
  left: 0;
  top: 3px;
  @media (min-width: ${theme.breakpoints.desktop}) {
    left: 20px;
    top: 3px;
  }

`;

class SearchInput extends React.Component {
  state = {
    searchKey: '',
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleEsc, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEsc, false);
  }

  handleEsc = (e) => {
    if (e.keyCode === 27) {
      this.props.closeModal('SEARCH');
      this.setState({ searchKey: '' });
    }
  };

  handleChange = (e) => {
    const searchKey = e.target.value;
    this.setState({ searchKey });
    const {
      openModal, closeModal, isSearchModalOpen, search, // eslint-disable-line
    } = this.props;
    if (searchKey === '') {
      closeModal('SEARCH');
      this.setState({ searchKey: '' });
    } else if (!isSearchModalOpen) {
      openModal('SEARCH');
    }
    search(searchKey);
  };


  render() {
    return (
      <SearchBar>
        <Icon
          size="23px"
          name="search"
        />
        <StyledInput
          placeholder="Search..."
          onChange={this.handleChange}
          value={this.state.searchKey}
          variant="ghost"
        />
      </SearchBar>
    );
  }
}
SearchInput.propTypes = {
  isSearchModalOpen: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
};
SearchInput.defaultProps = {
};

const mapStateToProps = (state) => ({
  isSearchModalOpen: getIsModalOpen(state, 'SEARCH'),
  searchKey: getSearchKey(state),
});

const mapDispatchToProps = {
  openModal,
  closeModal,
  search,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchInput);
